import styled from 'styled-components'
import { media } from '../theme'

const Desktop = styled.div`
  display: none;
  height: 100%;

  @media (min-height: 600px) and (min-width: ${p =>
      p.theme.mediaSizes.medium}px) {
    display: block;
  }
`

export default Desktop



// WEBPACK FOOTER //
// ./src/components/Desktop.js